<script>
  /* Svelte */
  import { slide } from "svelte/transition";
  import { beforeUpdate } from "svelte";

  beforeUpdate( () => {
    filters = $storeGlobal.searchFilter;
  })

  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";
  import {
    producers,
    mediums,
    stainings,
    transparencies,
    granulatings,
    qualities } from "../../stores/storeColors";

  /* Components */
  import Switch from "../ui/Switch.svelte";
  import Select from "../ui/Select.svelte";

  /* Filterobject */
  let filters = {
    vegan: false,
    lightfast: false,
    singlePigment: false,
    producer: 'All',
    medium: 'All',
    staining: 'All',
    transparency: 'All',
    granulation: 'All',
    quality: 'All'
  };

  /* Functions */
  const showVegan = () => {
    filters.vegan = !filters.vegan;
    storeGlobal.updateItem('searchFilter', filters);
  }

  const showSingle = () => {
    filters.singlePigment = !filters.singlePigment;
    storeGlobal.updateItem('searchFilter', filters);
  }

  const showLightfast = () => {
    filters.lightfast = !filters.lightfast;
    storeGlobal.updateItem('searchFilter', filters);
  }

  const searchNow = () => {
    storeGlobal.updateItem('searchFilter', filters);
  }

  const clearFilter = () => {
    let resetFilters = {
      vegan: false,
      lightfast: false,
      singlePigment: false,
      producer: 'All',
      medium: 'All',
      staining: 'All',
      transparency: 'All',
      granulation: 'All',
      quality: 'All'
    }

    storeGlobal.updateItem('searchFilter', resetFilters);
    storeGlobal.updateItem('showFilter', false);
  }
</script>

{#if $storeGlobal.showFilter }
  <div class="p-4
              border-t
              border-smoke
              w-full
              dark:border-slate
              dark:text-silver"
       transition:slide>

    <!-- Filters -->
    <form class="lg:flex flex-wrap">

      <!-- Dropdowns -->
      <div class="xs:flex xs:flex-wrap lg:w-4/5 xl:w-full xl:flex-end">
        <div class="xs:w-1/2 xs:pr-3 sm:w-1/3 xl:w-1/6">
          <Select name="Company" values={$producers} bind:value={ filters.producer } on:change="{ searchNow }" />
        </div>

        <div class="xs:w-1/2 xs:pr-2 sm:w-1/3 xl:w-1/6">
          <Select name="Medium" values={$mediums} bind:value={ filters.medium } on:change="{ searchNow }" />
        </div>

        <div class="xs:w-1/2 xs:pr-3 sm:w-1/3 xl:w-1/6">
          <Select name="Stain" values={$stainings} bind:value={ filters.staining } on:change="{ searchNow }" />
        </div>

        <div class="xs:w-1/2 xs:pr-2 sm:w-1/3 xl:w-1/6">
          <Select name="Transparency" values={$transparencies} bind:value={ filters.transparency } on:change="{ searchNow }" />
        </div>

        <div class="xs:w-1/2 xs:pr-2 sm:w-1/3 xl:w-1/6">
          <Select name="Granulation" values={$granulatings} bind:value={ filters.granulation } on:change="{ searchNow }" />
        </div>

        <div class="xs:w-1/2 xs:pr-2 sm:w-1/3 xl:w-1/6">
          <Select name="Quality" values={$qualities} bind:value={ filters.quality } on:change="{ searchNow }" />
        </div>


        <div class="xs:w-1/2 xs:pr-2 sm:w-1/3 xl:w-1/6 flex items-center justify-center">

          <button class="flex
                         items-center
                         border
                         border-smoke
                         text-silver
                         h-10
                         px-3
                         rounded-lg
                         ml-2
                         mt-4
                         transition-colors
                         duration-200
                         hover:bg-teal
                         hover:border-teal
                         hover:text-snow
                         focus:outline-none
                         dark:border-silver
                         dark-hover:bg-teal_d"
                  on:click|preventDefault="{ clearFilter }">
            Clear all filters
          </button>

        </div>
      </div>

      <!-- Switches -->
      <div class="flex xl:flex-row-reverse flex-wrap lg:w-1/5 lg:pl-8 lg:py-4 xl:p-0 xl:w-full">
        <div class="w-1/2 xs:w-1/3 lg:w-full xl:w-2/12">
          <Switch name="Only vegan" filter="vegan" on:click="{ showVegan }" />
        </div>

        <div class="w-1/2 xs:w-1/3 lg:w-full xl:w-2/12" >
          <Switch name="Only lightfast" filter="lightfast" on:click="{ showLightfast }" />
        </div>

        <div class="w-1/2 xs:w-1/3 lg:w-full xl:w-2/12">
          <Switch name="Single pigment" filter="singlePigment" on:click="{ showSingle }" />
        </div>
      </div>

    </form>

  </div>
{/if}
